import { BaseEntryScope, createEntryPoint } from '#packages/apilib';
import { createMobileBlockReparentingApi } from './api';
import { MobileBlockReparantingApiKey } from './publicApiKey';
import { EditorAPIKey, WorkspaceApiKey } from '#packages/apis';
import { RestrictedZoneHighlighter } from './components/RestrictedZoneHighlighter';

export class Scope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  workspaceAPI = this.useDependency(WorkspaceApiKey);
}

export const MobileBlockReparentingEntryPoint = createEntryPoint({
  name: 'MobileBlockReparenting',
  Scope,
  publicApi({ contributeApi }) {
    contributeApi(
      MobileBlockReparantingApiKey,
      createMobileBlockReparentingApi,
    );
  },

  initialize(scope) {
    scope.workspaceAPI.contributeMouseCatcherComponent(
      RestrictedZoneHighlighter,
    );
  },
});
